import _parseInt from 'lodash/parseInt';
import _map from 'lodash/map';
import APPCONFIG from '../../constants/Config';
import { WS_TOPIC_CUSTOMERS } from '../../constants/App';
import * as wsEvents from '../../constants/WsEvents';
import {
  REINIT_STATE,
  WS_RECEIVED_OPERATION,
  GET_INSTALLATION_CUSTOMERS_LIST,
  GET_INSTALLATION_CUSTOMERS_LIST_SUCCESS,
  GET_INSTALLATION_CUSTOMERS_LIST_ERROR,
  GET_INSTALLATION_CUSTOMER,
  GET_INSTALLATION_CUSTOMER_SUCCESS,
  GET_INSTALLATION_CUSTOMER_ERROR,
  ADD_INSTALLATION_CUSTOMER,
  ADD_INSTALLATION_CUSTOMER_SUCCESS,
  ADD_INSTALLATION_CUSTOMER_ERROR,
  UPDATE_INSTALLATION_CUSTOMER,
  UPDATE_INSTALLATION_CUSTOMER_SUCCESS,
  UPDATE_INSTALLATION_CUSTOMER_ERROR,
  UPDATE_INSTALLATION_CUSTOMER_STATE,
  UPDATE_INSTALLATION_CUSTOMER_STATE_SUCCESS,
  UPDATE_INSTALLATION_CUSTOMER_STATE_ERROR,
  DELETE_INSTALLATION_CUSTOMER,
  DELETE_INSTALLATION_CUSTOMER_SUCCESS,
  DELETE_INSTALLATION_CUSTOMER_ERROR,
  GET_INSTALLATION_CUSTOMER_ACCESSWAYS,
  GET_INSTALLATION_CUSTOMER_ACCESSWAYS_SUCCESS,
  GET_INSTALLATION_CUSTOMER_ACCESSWAYS_ERROR,
  GET_INSTALLATION_CUSTOMER_RANDOM_UNIQUE_KEYPAD_CODE,
  GET_INSTALLATION_CUSTOMER_RANDOM_UNIQUE_KEYPAD_CODE_SUCCESS,
  GET_INSTALLATION_CUSTOMER_RANDOM_UNIQUE_KEYPAD_CODE_ERROR,
  GENERATE_INSTALLATION_CUSTOMERS_DAILY_CODES,
  GENERATE_INSTALLATION_CUSTOMERS_DAILY_CODES_SUCCESS,
  GENERATE_INSTALLATION_CUSTOMERS_DAILY_CODES_ERROR,
  EXPORT_INSTALLATION_CUSTOMERS,
  EXPORT_INSTALLATION_CUSTOMERS_SUCCESS,
  EXPORT_INSTALLATION_CUSTOMERS_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize, deserializeAccessWay } from '../../models/customer';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.installationCustomer;
const installationCustomer = (state = initialSettings, action) => {
  let key;
  let wsPayload;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullInstallation' || action.target === 'currentInstallation') {
        return {
          ...state,
          list: { ...initialSettings.list },
          current: { ...initialSettings.current },
          add: { ...initialSettings.add },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
        };
      }
      switch (action.target) {
        case 'addInstallationCustomer':
          key = 'add';
          break;
        case 'updateInstallationCustomer':
          key = 'update';
          break;
        case 'deleteInstallationCustomer':
          key = 'delete';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
          list: {
            ...state.list,
            desynchronized: false,
          },
        };
      }
      return state;
    // WEB SOCKET
    case WS_RECEIVED_OPERATION:
      if (action.topic && action.topic === WS_TOPIC_CUSTOMERS) {
        switch (action.operation) {
          case wsEvents.EVENT_CREATE:
          case wsEvents.EVENT_UPDATE:
            return {
              ...state,
              list: {
                ...state.list,
                desynchronized: true,
              },
            };
          case wsEvents.EVENT_DELETE:
            wsPayload = action.payload;
            // In case of delete, desynchronize the list only if the delete does not concern the last deleted customer
            if (wsPayload.id !== state.delete.idCustomer) {
              return {
                ...state,
                list: {
                  ...state.list,
                  desynchronized: true,
                },
              };
            }
            return state;
          case wsEvents.EVENT_HEAD:
            wsPayload = action.payload;
            if (wsPayload) {
              // Update the list of customers by updating sync status of the concerned customer
              return {
                ...state,
                list: {
                  ...state.list,
                  elements: {
                    ...state.list.elements,
                    data: _map(state.list.elements.data, (customer) => (customer.id === wsPayload.id
                      ? {
                        ...customer,
                        sync_status: wsPayload.sync_status,
                      } : customer
                    )),
                  },
                },
              };
            }
            return state;
          default:
            return state;
        }
      }
      return state;
    // LIST
    case GET_INSTALLATION_CUSTOMERS_LIST:
      // Note: Display loading and reset data only if the action is asked by user (i.e. desynchronized is false)
      return {
        ...state,
        list: {
          ...state.list,
          loading: !action.desynchronized,
          desynchronized: false,
          error: null,
          elements: {
            ...state.list.elements,
            data: (action.desynchronized && state.list.elements.data) ? [...state.list.elements.data] : null,
          },
        },
      };
    case GET_INSTALLATION_CUSTOMERS_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          desynchronized: false,
          error: action.error,
        },
      };
    case GET_INSTALLATION_CUSTOMERS_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          desynchronized: false,
          elements: {
            ...state.list.elements,
            // TODO...
            data: deserialize(action.data.data),
            pageNumber: _parseInt(action.data.page_number),
            pageSize: _parseInt(action.data.page_size),
            totalEntries: _parseInt(action.data.total_entries),
            totalPages: _parseInt(action.data.total_pages),
          },
        },
      };
    // GET
    case GET_INSTALLATION_CUSTOMER:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_INSTALLATION_CUSTOMER_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case GET_INSTALLATION_CUSTOMER_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserialize(action.data.data),
        },
      };
    // ADD
    case ADD_INSTALLATION_CUSTOMER:
      return {
        ...state,
        add: {
          ...state.add,
          error: null,
        },
      };
    case ADD_INSTALLATION_CUSTOMER_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: action.error,
        },
      };
    case ADD_INSTALLATION_CUSTOMER_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
          asyncOperation: action.data.data,
        },
      };
    // UPDATE
    case UPDATE_INSTALLATION_CUSTOMER:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          idCustomer: action.idCustomer,
          error: null,
        },
      };
    case UPDATE_INSTALLATION_CUSTOMER_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case UPDATE_INSTALLATION_CUSTOMER_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
          asyncOperation: action.data.data,
        },
      };
    // UPDATE ANTIPASSBACK
    case UPDATE_INSTALLATION_CUSTOMER_STATE:
      return {
        ...state,
        updateState: {
          ...state.updateState,
          updated: false,
          idCustomer: action.idCustomer,
          error: null,
        },
      };
    case UPDATE_INSTALLATION_CUSTOMER_STATE_ERROR:
      return {
        ...state,
        updateState: {
          ...state.updateState,
          error: action.error,
        },
      };
    case UPDATE_INSTALLATION_CUSTOMER_STATE_SUCCESS:
      return {
        ...state,
        updateState: {
          ...state.updateState,
          updated: true,
          asyncOperation: action.data.data,
        },
      };
    // DELETE
    case DELETE_INSTALLATION_CUSTOMER:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          idCustomer: action.idCustomer,
          error: null,
        },
      };
    case DELETE_INSTALLATION_CUSTOMER_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case DELETE_INSTALLATION_CUSTOMER_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
        },
      };
    // LIST ACCESS WAYS
    case GET_INSTALLATION_CUSTOMER_ACCESSWAYS:
      return {
        ...state,
        accessWays: {
          ...state.accessWays,
          error: null,
          loading: true,
          idCustomer: action.idCustomer,
        },
      };
    case GET_INSTALLATION_CUSTOMER_ACCESSWAYS_ERROR:
      return {
        ...state,
        accessWays: {
          ...state.accessWays,
          loading: false,
          error: action.error,
        },
      };
    case GET_INSTALLATION_CUSTOMER_ACCESSWAYS_SUCCESS:
      // Update the list of customers by updating the access ways of the concerned customer
      return {
        ...state,
        list: {
          ...state.list,
          elements: {
            ...state.list.elements,
            data: _map(state.list.elements.data, (customer) => (customer.id === state.accessWays.idCustomer
              ? {
                ...customer,
                access_ways: deserializeAccessWay(action.data.data),
              } : customer
            )),
          },
        },
        accessWays: {
          ...state.accessWays,
          loading: false,
          error: null,
        },
      };
    // GET RANDOM UNIQUE CODE
    case GET_INSTALLATION_CUSTOMER_RANDOM_UNIQUE_KEYPAD_CODE:
      return {
        ...state,
        randomUniqueCode: {
          ...state.randomUniqueCode,
          loading: true,
          code: null,
          error: null,
        },
      };
    case GET_INSTALLATION_CUSTOMER_RANDOM_UNIQUE_KEYPAD_CODE_ERROR:
      return {
        ...state,
        randomUniqueCode: {
          ...state.randomUniqueCode,
          loading: false,
          error: action.error,
        },
      };
    case GET_INSTALLATION_CUSTOMER_RANDOM_UNIQUE_KEYPAD_CODE_SUCCESS:
      return {
        ...state,
        randomUniqueCode: {
          ...state.randomUniqueCode,
          loading: false,
          code: action.data.code,
        },
      };
    // GENERATE DAILY CODES
    case GENERATE_INSTALLATION_CUSTOMERS_DAILY_CODES:
      return {
        ...state,
        dailyCodes: {
          ...state.dailyCodes,
          done: false,
          size: 0,
          error: null,
        },
      };
    case GENERATE_INSTALLATION_CUSTOMERS_DAILY_CODES_ERROR:
      return {
        ...state,
        dailyCodes: {
          ...state.dailyCodes,
          done: false,
          error: action.error,
        },
      };
    case GENERATE_INSTALLATION_CUSTOMERS_DAILY_CODES_SUCCESS:
      return {
        ...state,
        dailyCodes: {
          ...state.dailyCodes,
          done: true,
          size: _parseInt(action.data.size),
        },
      };
    // EXPORT
    case EXPORT_INSTALLATION_CUSTOMERS:
      return {
        ...state,
        export: {
          ...state.export,
          done: false,
          error: null,
        },
      };
    case EXPORT_INSTALLATION_CUSTOMERS_ERROR:
      return {
        ...state,
        export: {
          ...state.export,
          done: false,
          error: action.error,
        },
      };
    case EXPORT_INSTALLATION_CUSTOMERS_SUCCESS:
      return {
        ...state,
        export: {
          ...state.export,
          done: true,
        },
      };
    default:
      return state;
  }
};

export default installationCustomer;



// WEBPACK FOOTER //
// ./reducers/installation/installationCustomer.js